module.exports = __webpack_public_path__ + "img/alquiler-equipos-viales.a9fc1bc0.png";